import PropTypes from 'prop-types'

/** Shortcut for atom proptype validator. */
export const PropTypesAtom = PropTypes.shape({
  _alive: PropTypes.bool.isRequired,
})
